<h2 mat-dialog-title>Generate Patient Statement</h2>
<mat-dialog-content>
  <form [formGroup]="statementForm">
    <div class="date-range-chips">
      <mat-chip-listbox [(ngModel)]="selectedDateRange" [ngModelOptions]="{standalone: true}"
        (change)="onDateRangeSelection($event)">
        <mat-chip-option value="all">All Time</mat-chip-option>
        <mat-chip-option value="120">120 Days</mat-chip-option>
        <mat-chip-option value="90">90 Days</mat-chip-option>
        <mat-chip-option value="60">60 Days</mat-chip-option>
        <mat-chip-option value="30">30 Days</mat-chip-option>
        <mat-chip-option value="7">7 Days</mat-chip-option>
      </mat-chip-listbox>
    </div>

    <div class="statement-date-picker">
      <mat-form-field appearance="outline">
        <mat-label>From Date</mat-label>
        <input matInput [matDatepicker]="fromPicker" formControlName="startDate" [max]="maxDate">
        <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
        <mat-datepicker #fromPicker></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>To Date</mat-label>
        <input matInput [matDatepicker]="toPicker" formControlName="endDate" [max]="maxDate">
        <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
        <mat-datepicker #toPicker></mat-datepicker>
      </mat-form-field>
    </div>

    <div class="vat-exclusive-toggle">
      <mat-checkbox formControlName="vatExclusive"
        matTooltip="Tick this for schemes like WCA. The PDF removes the per-line VAT column and shows the totals VAT-exclusive.">
        Display prices VAT exclusive (e.g. WCA)
      </mat-checkbox>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Cancel</button>
  <button mat-button color="primary" (click)="generate()" [disabled]="statementForm.invalid">Generate</button>
</mat-dialog-actions>